export const BORDER_RADIUS = "3rem";
